import { render, staticRenderFns } from "./VueDropzone.vue?vue&type=template&id=1f1dac2d"
import script from "./VueDropzone.vue?vue&type=script&lang=js"
export * from "./VueDropzone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f1dac2d')) {
      api.createRecord('1f1dac2d', component.options)
    } else {
      api.reload('1f1dac2d', component.options)
    }
    module.hot.accept("./VueDropzone.vue?vue&type=template&id=1f1dac2d", function () {
      api.rerender('1f1dac2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/VueDropzone.vue"
export default component.exports